/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import theme from '../../theme';

import AddSvg from './svgs/add.svg';
import BadgePercentSvg from './svgs/badge-percent.svg';
import BankCardSvg from './svgs/bank-card.svg';
import BillCircleeSvg from './svgs/bill-circlee.svg';
import BoxSvg from './svgs/box.svg';
import BrainCircuitSvg from './svgs/brain-circuit.svg';
import BrandSvg from './svgs/brand.svg';
import BrandLogoSvg from './svgs/brand-logo.svg';
import BulletSvg from './svgs/bullet.svg';
import BusinessSvg from './svgs/business.svg';
import CalendarSvg from './svgs/calendar.svg';
import CenterFocusSvg from './svgs/center-focus.svg';
import CheckSvg from './svgs/check.svg';
import CommentsSvg from './svgs/comments.svg';
import CrossSvg from './svgs/cross.svg';
import CloseSvg from './svgs/close.svg';
import ClockSvg from './svgs/clock.svg';
import CoinsSvg from './svgs/coins.svg';
import ControlSvg from './svgs/control.svg';
import CopySvg from './svgs/copy.svg';
import CrownSvg from './svgs/crown.svg';
import CutlerySvg from './svgs/cutlery.svg';
import DatabaseSvg from './svgs/database.svg';
import DecreaseSvg from './svgs/decrease.svg';
import DeleteSvg from './svgs/delete.svg';
import DigitalKeySvg from './svgs/digital-key.svg';
import DeliverySvg from './svgs/delivery.svg';
import DisconnectedSvg from './svgs/disconnected.svg';
import DownArrowSvg from './svgs/down-arrow.svg';
import DownloadSvg from './svgs/download.svg';
import EditSvg from './svgs/edit.svg';
import EuroSvg from './svgs/euro.svg';
import ExpandSvg from './svgs/expand.svg';
import FacebookSvg from './svgs/facebook.svg';
import GpsSvg from './svgs/gps.svg';
import HeartSvg from './svgs/heart.svg';
import HeartPartnerHandshakeSvg from './svgs/heart-partner-handshake.svg';
import IncreaseSvg from './svgs/increase.svg';
import InfoSvg from './svgs/info.svg';
import InstagramSvg from './svgs/instagram.svg';
import KeySvg from './svgs/key.svg';
import LeafSvg from './svgs/leaf.svg';
import LeftArrowSvg from './svgs/left-arrow.svg';
import ListSvg from './svgs/list.svg';
import LogoApplePaySvg from './svgs/logo-apple-pay.svg';
import LogoBimpliSvg from './svgs/logo-bimpli.svg';
import LogoChequeDejeunerSvg from './svgs/logo-cheque-dejeuner.svg';
import LogoEdenredSvg from './svgs/logo-edenred.svg';
import LogoGooglePaySvg from './svgs/logo-google-pay.svg';
import LogoPluxeeSvg from './svgs/logo-pluxee.svg';
import LogoRestoflashSvg from './svgs/logo-restoflash.svg';
import LogoSodexoSvg from './svgs/logo-sodexo.svg';
import LogoSwanSvg from './svgs/logo-swan.svg';
import LogoSwileSvg from './svgs/logo-swile.svg';
import LogoTreezorSvg from './svgs/logo-treezor.svg';
import LogoUpDejeunerSvg from './svgs/logo-up-dejeuner.svg';
import LoyaltySvg from './svgs/loyalty.svg';
import LunchboxSvg from './svgs/lunchbox.svg';
import MailSvg from './svgs/mail.svg';
import MaleGenderSvg from './svgs/male-gender.svg';
import MastercardSvg from './svgs/mastercard.svg';
import MenuSvg from './svgs/menu.svg';
import MapSvg from './svgs/map.svg';
import MoneySvg from './svgs/money.svg';
import MoveSvg from './svgs/move.svg';
import OrdersSvg from './svgs/orders.svg';
import PadlockSvg from './svgs/padlock.svg';
import PageSvg from './svgs/page.svg';
import PaymentMethodSvg from './svgs/payment-method.svg';
import PhoneSvg from './svgs/phone.svg';
import PhotoSvg from './svgs/photo.svg';
import PinSvg from './svgs/pin.svg';
import PlaySvg from './svgs/play.svg';
import PlusSvg from './svgs/plus.svg';
import PowerButtonSvg from './svgs/power-button.svg';
import PremiumSvg from './svgs/premium.svg';
import PreviewSvg from './svgs/preview.svg';
import PrintSvg from './svgs/print.svg';
import ProductSvg from './svgs/product.svg';
import ProfitSvg from './svgs/profit.svg';
import PuzzlePieceIntegrationSvg from './svgs/puzzle-piece-integration.svg';
import QrCodeSvg from './svgs/qr-code.svg';
import RefreshSvg from './svgs/refresh.svg';
import RightArrowSvg from './svgs/right-arrow.svg';
import RocketSvg from './svgs/rocket.svg';
import RoosterSvg from './svgs/rooster.svg';
import RotateLeftSvg from './svgs/rotate-left.svg';
import SearchSvg from './svgs/search.svg';
import SettingsSvg from './svgs/settings.svg';
import ShareSvg from './svgs/share.svg';
import ShieldCheckSvg from './svgs/shield-check.svg';
import ShopSvg from './svgs/shop.svg';
import ShoppingBagSvg from './svgs/shopping-bag.svg';
import StableSvg from './svgs/stable.svg';
import StoreSvg from './svgs/store.svg';
import TakeAwaySvg from './svgs/take-away.svg';
import TimeFastSvg from './svgs/time-fast.svg';
import TicketProSvg from './svgs/ticket-pro.svg';
import TicketRestaurantEdenredSvg from './svgs/ticket-restaurant-edenred.svg';
import TwitterSvg from './svgs/twitter.svg';
import UserSvg from './svgs/user.svg';
import VisibleSvg from './svgs/visibility.svg';
import InvisibleSvg from './svgs/invisible.svg';
import InvoiceSvg from './svgs/invoice.svg';
import VisaSvg from './svgs/visa.svg';
import WheelSvg from './svgs/wheel.svg';
import WomanSvg from './svgs/woman.svg';

export const ICONS = {
  add: (props) => <AddSvg {...props} />,
  'badge-percent': (props) => <BadgePercentSvg {...props} />,
  'bank-card': (props) => <BankCardSvg {...props} />,
  'bill-circlee': (props) => <BillCircleeSvg {...props} />,
  box: (props) => <BoxSvg {...props} />,
  'brain-circuit': (props) => <BrainCircuitSvg {...props} />,
  brand: (props) => <BrandSvg {...props} />,
  'brand-logo': (props) => <BrandLogoSvg {...props} />,
  bullet: (props) => <BulletSvg {...props} />,
  business: (props) => <BusinessSvg {...props} />,
  calendar: (props) => <CalendarSvg {...props} />,
  'center-focus': (props) => <CenterFocusSvg {...props} />,
  check: (props) => <CheckSvg {...props} />,
  cross: (props) => <CrossSvg {...props} />,
  clock: (props) => <ClockSvg {...props} />,
  close: (props) => <CloseSvg {...props} />,
  comments: (props) => <CommentsSvg {...props} />,
  coins: (props) => <CoinsSvg {...props} />,
  control: (props) => <ControlSvg {...props} />,
  copy: (props) => <CopySvg {...props} />,
  crown: (props) => <CrownSvg {...props} />,
  cutlery: (props) => <CutlerySvg {...props} />,
  database: (props) => <DatabaseSvg {...props} />,
  decrease: (props) => <DecreaseSvg {...props} />,
  delete: (props) => <DeleteSvg {...props} />,
  'digital-key': (props) => <DigitalKeySvg {...props} />,
  delivery: (props) => <DeliverySvg {...props} />,
  disconnected: (props) => <DisconnectedSvg {...props} />,
  'down-arrow': (props) => <DownArrowSvg {...props} />,
  download: (props) => <DownloadSvg {...props} />,
  'logo-edenred': (props) => <LogoEdenredSvg {...props} />,
  edit: (props) => <EditSvg {...props} />,
  euro: (props) => <EuroSvg {...props} />,
  expand: (props) => <ExpandSvg {...props} />,
  facebook: (props) => <FacebookSvg {...props} />,
  gps: (props) => <GpsSvg {...props} />,
  heart: (props) => <HeartSvg {...props} />,
  'heart-partner-handshake': (props) => <HeartPartnerHandshakeSvg {...props} />,
  increase: (props) => <IncreaseSvg {...props} />,
  info: (props) => <InfoSvg {...props} />,
  instagram: (props) => <InstagramSvg {...props} />,
  key: (props) => <KeySvg {...props} />,
  leaf: (props) => <LeafSvg {...props} />,
  'left-arrow': (props) => <LeftArrowSvg {...props} />,
  list: (props) => <ListSvg {...props} />,
  'logo-apple-pay': (props) => <LogoApplePaySvg {...props} />,
  'logo-bimpli': (props) => <LogoBimpliSvg {...props} />,
  'logo-cheque-dejeuner': (props) => <LogoChequeDejeunerSvg {...props} />,
  'logo-google-pay': (props) => <LogoGooglePaySvg {...props} />,
  'logo-pluxee': (props) => <LogoPluxeeSvg {...props} />,
  'logo-restoflash': (props) => <LogoRestoflashSvg {...props} />,
  'logo-sodexo': (props) => <LogoSodexoSvg {...props} />,
  'logo-swan': (props) => <LogoSwanSvg {...props} />,
  'logo-swile': (props) => <LogoSwileSvg {...props} />,
  'logo-treezor': (props) => <LogoTreezorSvg {...props} />,
  'logo-up-dejeuner': (props) => <LogoUpDejeunerSvg {...props} />,
  loyalty: (props) => <LoyaltySvg {...props} />,
  lunchbox: (props) => <LunchboxSvg {...props} />,
  mail: (props) => <MailSvg {...props} />,
  money: (props) => <MoneySvg {...props} />,
  male: (props) => <MaleGenderSvg {...props} />,
  map: (props) => <MapSvg {...props} />,
  mastercard: (props) => <MastercardSvg {...props} />,
  menu: (props) => <MenuSvg {...props} />,
  move: (props) => <MoveSvg {...props} />,
  orders: (props) => <OrdersSvg {...props} />,
  padlock: (props) => <PadlockSvg {...props} />,
  page: (props) => <PageSvg {...props} />,
  'payment-method': (props) => <PaymentMethodSvg {...props} />,
  phone: (props) => <PhoneSvg {...props} />,
  photo: (props) => <PhotoSvg {...props} />,
  pin: (props) => <PinSvg {...props} />,
  play: (props) => <PlaySvg {...props} />,
  plus: (props) => <PlusSvg {...props} />,
  'power-button': (props) => <PowerButtonSvg {...props} />,
  premium: (props) => <PremiumSvg {...props} />,
  preview: (props) => <PreviewSvg {...props} />,
  print: (props) => <PrintSvg {...props} />,
  product: (props) => <ProductSvg {...props} />,
  profit: (props) => <ProfitSvg {...props} />,
  'puzzle-piece-integration': (props) => <PuzzlePieceIntegrationSvg {...props} />,
  'qr-code': (props) => <QrCodeSvg {...props} />,
  refresh: (props) => <RefreshSvg {...props} />,
  'right-arrow': (props) => <RightArrowSvg {...props} />,
  rocket: (props) => <RocketSvg {...props} />,
  rooster: (props) => <RoosterSvg {...props} />,
  search: (props) => <SearchSvg {...props} />,
  'rotate-left': (props) => <RotateLeftSvg {...props} />,
  settings: (props) => <SettingsSvg {...props} />,
  shop: (props) => <ShopSvg {...props} />,
  share: (props) => <ShareSvg {...props} />,
  'shield-check': (props) => <ShieldCheckSvg {...props} />,
  'shopping-bag': (props) => <ShoppingBagSvg {...props} />,
  stable: (props) => <StableSvg {...props} />,
  store: (props) => <StoreSvg {...props} />,
  'take-away': (props) => <TakeAwaySvg {...props} />,
  'time-fast': (props) => <TimeFastSvg {...props} />,
  twitter: (props) => <TwitterSvg {...props} />,
  'ticket-pro': (props) => <TicketProSvg {...props} />,
  'ticket-restaurant-edenred': (props) => <TicketRestaurantEdenredSvg {...props} />,
  user: (props) => <UserSvg {...props} />,
  female: (props) => <WomanSvg {...props} />,
  visible: (props) => <VisibleSvg {...props} />,
  invisible: (props) => <InvisibleSvg {...props} />,
  invoice: (props) => <InvoiceSvg {...props} />,
  visa: (props) => <VisaSvg {...props} />,
  wheel: (props) => <WheelSvg {...props} />,
};

export const SIZES = {
  small: '10px',
  medium: '14px',
  large: '20px',
  'extra-large': '30px',
};

export const COLORS = {
  primary: theme.palette.icon.primary,
  secondary: theme.palette.icon.secondary,
  tertiary: theme.palette.icon.tertiary,
  'text-primary': theme.palette.icon.textPrimary,
  'text-secondary': theme.palette.icon.textSecondary,
  contrast: theme.palette.icon.contrast,
};
